import React from 'react';
import {Button as NativeButton} from 'native-base';
import {message} from '../../utils/messages';

interface Props {
  label: string;
  onPress: () => void;
}

const Button = (props: Props) => {
  const {label, onPress: handleOnPress} = props;
  return (
    <NativeButton
      width="100%"
      borderRadius="10"
      backgroundColor="red.400"
      color="white"
      fontStyle="normal"
      fontWeight="extrabold"
      onPress={() => handleOnPress()}>
      {message(label)}
    </NativeButton>
  );
};

export default Button;
